import Award1 from 'images/home/award1.png'
import Award1Title from 'images/home/award1_title.png'
import Award2 from 'images/home/award2.png'
import Award2Title from 'images/home/award2_title.png'
import Award3 from 'images/home/award3.png'
import Award3Title from 'images/home/award3_title.png'
import BingoClash from 'images/home/BingoClash.png'
import BingoTour from 'images/home/BingoTour.png'
import BubbleBuzz from 'images/home/BubbleBuzz.png'
import EightBallStrike from 'images/home/EightBallStrike.png'
import Pocket7games from 'images/home/Pocket7Games.png'
import PoolCash from 'images/home/PoolCash.png'
import SolitaireClash from 'images/home/SolitaireClash.png'
import SolitaireVenture from 'images/home/SolitaireVenture.png'
import { StaticImageData } from 'next/image'
import {
  BingoClashEntity,
  BingoTourEntity,
  BubbleBuzzEntity,
  CashPoolEntity,
  EightBallStrikeEntity,
  GameEntity,
  Pocket7GamesEntity,
  SolitaireClashEntity,
  SolitaireVentureEntity,
} from './games'

export const HomeTopTitle = {
  title: 'Quick to Play, Quick to Win',
  description: 'To Unleash the Competitive Spirit in Everyone',
}

export const HomeGameTitle = {
  title: 'Quick, Fun, and Rewarding',
  description: [
    'Our games are easy to learn, fun to play, and challenging to master. ',
    'Put your skills to the test and win prizes in just minutes!',
  ],
}

export const HomeAwardsTitle = {
  title: 'Awards & Honors',
  description: ['We have received a variety of gaming awards for our', 'fun and innovative games!'],
}

export const HomePlayersTitle = {
  title: 'Why Players Love Avia',
  description: ['Check out what our players have to say about us!'],
}

export const HomeExperiencesTitle = {
  title: 'We Strive for Better Player Experiences',
}

export const HomeNewsTitle = {
  title: 'What’s Happening Now',
}

export const HomeGamesList: (Pick<GameEntity, 'key' | 'route'> & {
  content: StaticImageData
  video: Path
})[] = [
  {
    ...SolitaireClashEntity,
    content: SolitaireClash,
    video: '/SolitaireClash0508.mp4',
  },
  {
    ...BingoTourEntity,
    content: BingoTour,
    video: '/BingoTour0508.mp4',
  },
  {
    ...BingoClashEntity,
    content: BingoClash,
    video: '/BingoClash0508.mp4',
  },
  {
    ...EightBallStrikeEntity,
    content: EightBallStrike,
    video: '/8BallStrike0508.mp4',
  },
  {
    ...Pocket7GamesEntity,
    content: Pocket7games,
    video: '/Pocket7Games0508.mp4',
  },
  {
    ...SolitaireVentureEntity,
    content: SolitaireVenture,
    video: '/SolitaireVenture0508.mp4',
  },
  {
    ...BubbleBuzzEntity,
    content: BubbleBuzz,
    video: '/BubbleBuzz0508.mp4',
  },
  {
    ...CashPoolEntity,
    content: PoolCash,
    video: '/CashPool0508.mp4',
  },
]

export const HomeAwardsList = [
  {
    content: Award1,
    title: Award1Title,
  },
  {
    content: Award2,
    title: Award2Title,
  },
  {
    content: Award3,
    title: Award3Title,
  },
]
export const GameRecordList = [
  {
    title: '450M+',
    description: 'Monthly Tournaments',
  },
  {
    title: '60M+',
    description: 'Total Downloads',
  },
  {
    title: '$60M',
    description: 'Total Funding',
  },
]
